import { Brand, Domains, LegalArea, MediaLogo } from "@/core/types/types";

const MEDIA_LOGOS: {
  [key in keyof typeof Brand as string]: MediaLogo[];
} = {
  [Brand.ALLRIGHT]: [
    {
      logo: "stiftung_warentest-tz.svg",
    },
    {
      logo: "omk-wirtschafts_woche.svg",
    },
    {
      logo: "frankfurter-allgemeine.svg",
    },
  ],
  [Brand.FLUGRECHT]: [
    {
      logo: "stern.svg",
      width: 110,
    },
    {
      logo: "focus.svg",
      width: 82,
    },
    {
      logo: "computer.svg",
      width: 90,
    },
  ],
  [Brand.FLYGHJALP]: [
    {
      logo: "aftobladet-logo.svg",
    },
    {
      logo: "svt-logo.svg",
    },
    {
      logo: "dagensnyheter-logo.svg",
    },
  ],
  [Brand.FLYHJAELP]: [
    {
      logo: "dk-logo-dr.svg",
      width: 120,
    },
    {
      logo: "dk-logo-berlingske.svg",
    },
    {
      logo: "dk-logo-tv.svg",
      width: 50,
    },
  ],
  [Brand.FLYHJELP]: [
    {
      logo: "finansavisen.svg",
    },
    {
      logo: "nettavisen.svg",
    },
    {
      logo: "norsk-rikskringkasting.svg",
      width: 100,
    },
  ],
  [Brand.LENTOAPU]: [
    {
      logo: "helsingin-logo.svg",
    },
    {
      logo: "svt-logo.svg",
    },
    {
      logo: "iltalehti-logo.svg",
    },
  ],
  [Brand.REFUNDMORE]: [
    {
      logo: "dagens.svg",
      width: 120,
    },
    {
      logo: "svt.svg",
    },
    {
      logo: "rikskringkasting.svg",
      width: 100,
    },
  ],
  [Brand.CHEVALIER]: [
    {
      logo: "frankfurter-rundschau.svg",
      height: 35,
    },
    {
      logo: "suddeutsche-zeitung.svg",
      height: 35,
    },
    {
      logo: "focus-bild.svg",
      width: 120,
      height: 30,
    },
  ],
};

const FLIGHTRIGHT_MEDIA_LOGOS_BY_DOMAIN: {
  [key in keyof typeof Domains as string]: MediaLogo[];
} = {
  [Domains.DE]: [
    {
      logo: "diezeit.svg",
    },
    {
      logo: "rtl.svg",
    },
    {
      logo: "sdz.svg",
    },
  ],
  [Domains.AT]: [
    {
      logo: "derstandard.svg",
    },
    {
      logo: "oe24.svg",
      width: 120,
    },
    {
      logo: "puls24.svg",
    },
  ],
  [Domains.COM]: [
    {
      logo: "nytimes.svg",
    },
    {
      logo: "forbes.svg",
      width: 140,
    },
    {
      logo: "cbsnews.svg",
    },
  ],
  [Domains.UK]: [
    {
      logo: "daily-mail.svg",
    },
    {
      logo: "mirror.svg",
      width: 100,
    },
    {
      logo: "travelweekly.svg",
    },
  ],
  [Domains.FR]: [
    {
      logo: "lemonde.svg",
    },
    {
      logo: "capital.svg",
      width: 140,
    },
    {
      logo: "BFM.svg",
      width: 70,
    },
  ],
  [Domains.ES]: [
    {
      logo: "elmundo.svg",
    },
    {
      logo: "businessinsider.svg",
      width: 120,
    },
    {
      logo: "elconfidencial.svg",
    },
  ],
  [Domains.SE]: [
    {
      logo: "nytimes.svg",
    },
    {
      logo: "forbes.svg",
      width: 140,
    },
    {
      logo: "cbsnews.svg",
    },
  ],
  [Domains.NET]: [
    {
      logo: "diezeit.svg",
    },
    {
      logo: "rtl.svg",
    },
    {
      logo: "sdz.svg",
    },
  ],
};

export default function getMediaLogosForBrand(
  brandName: Brand,
  legalArea: LegalArea,
  domain: Domains
): any {
  if (legalArea === LegalArea.APR) {
    return brandName === Brand.FLIGHTRIGHT
      ? { logos: FLIGHTRIGHT_MEDIA_LOGOS_BY_DOMAIN[domain], gap: 2 }
      : { logos: MEDIA_LOGOS[brandName], gap: 2 };
  }

  return { logos: MEDIA_LOGOS[brandName], gap: 1 };
}
